<template>
    <BaseButton
        v-bind="props"
        :class="[
            ghostStyles.ghost_button_override,
            ghostStyles[`color_${props.color}_override`],
            iconStyles[`size_${props.size}_override`],
        ]"
    >
        <Icon
            v-if="props.icon"
            :name="props.icon"
            :class="iconStyles.icon"
        />
        <div
            v-else
            :class="iconStyles.icon"
        />
    </BaseButton>
</template>

<script lang="ts" setup>
import type { HTMLAttributes } from 'vue'

import type { IconNameType } from '@/components/Icon'
import Icon from '@/components/Icon/Icon.vue'

import BaseButton, { type BaseButtonProps } from './components/BaseButton.vue'
import ghostStyles from './styles/ghost.module.css'
import iconStyles from './styles/icon.module.css'

type Props = {
    icon?: IconNameType
} & BaseButtonProps &
    /* @vue-ignore */ Omit<HTMLAttributes, 'hidden'>

const props = withDefaults(defineProps<Props>(), {
    type: 'button',
    size: 'm',
    width: 'normal',
    color: 'purple-400',
})
</script>
